import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "strokeordertypes"
    }}>{`StrokeOrderTypes`}</h1>
    <p>{`Options for displaying row and column strokes at corners.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ROW_ON_TOP`}</strong>{` = 1936879476`}</p>
      <p parentName="blockquote">{`Places row strokes in front of column strokes.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`COLUMN_ON_TOP`}</strong>{` = 1935896436`}</p>
      <p parentName="blockquote">{`Places column strokes in front of row strokes.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BEST_JOINS`}</strong>{` = 1935828330`}</p>
      <p parentName="blockquote">{`Places row strokes in front of column strokes when row and column strokes are different colors; joins striped strokes and connects crossing points.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`INDESIGN_2_COMPATIBILITY`}</strong>{` = 1936286819`}</p>
      <p parentName="blockquote">{`Places row strokes in front when row and column strokes are different colors; joins striped strokes only at points where strokes cross in a T-shape.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      